/**
 * External Dependencies
 */

import 'bootstrap';
import * as zoomwall from './zoomwall.js';
import Glightbox from 'glightbox';
import 'ripplet.js/es/ripplet-declarative';
import Cookies from 'js-cookie'
import SidebarMenu from 'metismenujs';
import shareon from 'shareon';

const ajaxUrl = '/wp/wp-admin/admin-ajax.php';

window.addEventListener( 'load', function () {

    // Home Slider
    const hslider = document.getElementsByClassName( 'carousel-item' );

    for(var i = 0; i < hslider.length; i++)
    {
        if ( i === 0 ) { hslider[i].classList.add( 'active' ); }

    }


    // Home Gallery
    let hgallery = document.getElementById( 'zoomwall' );

    if( typeof( hgallery ) != 'undefined' && hgallery != null )
    {
        zoomwall.create( hgallery, true );
    }


    // Lightbox
    const lightbox = Glightbox({
        selector: '.lightbox',
        touchNavigation: true
    });


    // Lightbox Block Gallery
    const gallery = Glightbox({
        selector: '.blocks-gallery-item > figure > a',
        touchNavigation: true
    });


    // Blind Mode
    let accesible = Cookies.get('site_accesible');

    if ( 'true' === accesible ) {
        document.body.classList.add( 'site-accesible' );
    }

    document.getElementById( 'btnHeaderAccesible' ).onclick = function(e) {
        e.preventDefault();

        accesible = Cookies.get('site_accesible');

        if ( 'true' === accesible ) {
            Cookies.set('site_accesible', 'false');
        } else {
            Cookies.set('site_accesible', 'true');
        }

        document.body.classList.toggle( 'site-accesible' );
    };


    // Search Bar show/hide
    let searchBar = document.getElementById( 'navbarSearch' );

    document.getElementById( 'btnHeaderSearch' ).onclick = function(e) {
        e.preventDefault();
        searchBar.style.setProperty('--animate-duration', '0.2s');
        searchBar.classList.remove( 'd-none', 'animated', 'fadeOutUp' );
        searchBar.classList.add( 'animated', 'fadeInDown' );
    };

    document.getElementById( 'navbarSearchClose' ).onclick = function(e) {
        e.preventDefault();
        searchBar.classList.remove( 'animated', 'fadeInDown' );
        searchBar.classList.add( 'animated', 'fadeOutUp' );
    };


    // Contact Form
    let forms = document.querySelectorAll( '.needs-validation' )

    Array.prototype.slice.call( forms )
    .forEach( function ( form ) {
        form.addEventListener( 'submit', function (e) {
            if (!form.checkValidity()) {
                e.preventDefault();
                e.stopPropagation();
            }

            form.classList.add( 'was-validated' )
        }, false)
    })

    function sendForm(form) {
        const XHR = new XMLHttpRequest();
        const FD = new FormData( form );
        const msg = document.getElementById( 'formMessage' );
        const loader = document.getElementById( 'formLoader' )

        loader.classList.remove( 'd-none' );

        form.style.opacity = '0.2';

        msg.classList.remove( 'animated', 'fadeIn' );
        msg.classList.add( 'animated', 'fadeOut' );

        XHR.addEventListener( 'load', function(e) {

            let response = JSON.parse( e.target.responseText );

            loader.classList.add( 'd-none' );
            form.style.opacity = '1';
            msg.classList.remove( 'd-none', 'fadeOut' );
            msg.classList.add( 'animated', 'fadeIn' );

            if ( response.success === false ) {

                msg.classList.add( 'alert-danger' );
                msg.innerHTML = response.data;

            } else {

	            form.reset();
	            form.classList.add( 'd-none', 'fadeIn' );

	            msg.classList.add( 'alert-success' );
	            msg.innerHTML = response.data;

            }

        } );

        XHR.addEventListener( 'error', function( e ) {

            loader.classList.add( 'd-none' );

            msg.classList.remove( 'd-none', 'fadeOut' );
            msg.classList.add( 'alert-danger', 'animated', 'fadeIn' );

            msg.innerHTML = 'Ошибка обработки формы, попробуйте повторить отправку позднее.';

        } );

        XHR.open( 'POST', ajaxUrl );
        XHR.send( FD );
    }

    let formContact = document.getElementById('formContact');

    if( typeof( formContact ) != 'undefined' && formContact != null )
    {
        formContact.addEventListener( 'submit', function (e) {
            e.preventDefault();

            if ( formContact.checkValidity() ) {
                sendForm( formContact );
            }
        } );
    }


    // Phone mask

    [].forEach.call( document.querySelectorAll('[data-js="tel"]'), function(input) {
    var keyCode;
    function mask(event) {
        event.keyCode && (keyCode = event.keyCode);
        var pos = this.selectionStart;
        if (pos < 3) event.preventDefault();
        var matrix = "+7 (___) ___-__-__",
            i = 0,
            def = matrix.replace(/\D/g, ""),
            val = this.value.replace(/\D/g, ""),
            new_value = matrix.replace(/[_\d]/g, function(a) {
                return i < val.length ? val.charAt(i++) || def.charAt(i) : a
            });
        i = new_value.indexOf("_");
        if (i != -1) {
            i < 5 && (i = 3);
            new_value = new_value.slice(0, i)
        }
        var reg = matrix.substr(0, this.value.length).replace(/_+/g,
            function(a) {
                return "\\d{1," + a.length + "}"
            }).replace(/[+()]/g, "\\$&");
        reg = new RegExp("^" + reg + "$");
        if (!reg.test(this.value) || this.value.length < 5 || keyCode > 47 && keyCode < 58) this.value = new_value;
        if (event.type == "blur" && this.value.length < 5)  this.value = ""
    }

    input.addEventListener("input", mask, false);
    input.addEventListener("focus", mask, false);
    input.addEventListener("blur", mask, false);
    input.addEventListener("keydown", mask, false)

  });



    // Page sidebar navigation
    let sidebarNav = document.getElementById('pageSidebarNav');

    if( typeof( sidebarNav ) != 'undefined' && sidebarNav != null )
    {
        const sidebarNavChild = sidebarNav.querySelectorAll('.page_item_has_children > a');
        const sidebarNavActive = sidebarNav.querySelectorAll('.current_page_item, .current_page_parent, .current_page_ancestor');
        const sidebarNavShow = sidebarNav.querySelectorAll('.current_page_item > ul, .current_page_ancestor > ul, .current_page_parent > ul');
        const mm = new SidebarMenu(sidebarNav);

        sidebarNavChild.forEach(item => item.classList.add("has-arrow"));
        sidebarNavActive.forEach(item => item.classList.add("mm-active"));
        sidebarNavShow.forEach(item => item.classList.remove("mm-collapse"));
    }

    // Share buttons
    shareon();
});
